import Layout from '@/layout/index.vue'
export const manageRouter = [
  {
    path: '/manage',
    activeMenu: '/manage',
    resourceId: '18',
    parentId: null,
    meta: {
      title: '管理后台',
      icon: 'admin_back',
      activeMenu: '/manage',
      menu: true,
      sort: 30
    },
    component: Layout,
    children: [
      {
        path: '/manage/amc-dashbi/dashManage',
        name: '/manage/amc-dashbi/dashManage',
        resourceId: '1809',
        parentId: '18',
        component: () => import(/* webpackChunkName: "amc-dashbi" */ '@/views/manage/dashBi/index.vue'),
        meta: {
          title: '数据页面管理',
          icon: 'el-icon-s-marketing',
          activeMenu: '/manage/amc-dashbi/dashManage',
          routerBase: '/manage/amc-dashbi'
        }
      },
      {
        path: '/manage/amc-dashbi/*',
        name: '/manage/amc-dashbi',
        resourceId: '1809',
        parentId: '18',
        component: () => import(/* webpackChunkName: "amc-dashbi" */ '@/views/manage/dashBi/index.vue'),
        meta: {
          title: '数据页面管理',
          icon: 'el-icon-s-marketing',
          activeMenu: '/manage/amc-dashbi',
          hidden: true,
          routerBase: '/manage/amc-dashbi'
        }
      },
      {
        path: '/manage/tenantStory',
        name: '/manage/tenantStory',
        resourceId: '1808',
        parentId: '18',
        component: () => import(/* webpackChunkName: "tenantStory" */ '@/views/manage/tenantStory/index.vue'),
        meta: {
          title: '故事线选择',
          icon: 'el-icon-s-platform',
          activeMenu: '/manage/tenantStory'
        }
      },
      {
        path: '/manage/storyDetail',
        component: () => import(/* webpackChunkName: "tenantStory" */ '@/views/manage/tenantStory/template/storyDetail/index.vue'),
        name: 'tenantStoryDetail',
        meta: {
          title: '故事线详情',
          activeMenu: '/manage/tenantStory',
          hidden: true
        }
      },
      {
        path: '/manage/portfolioDataManage',
        resourceId: '1801',
        parentId: '18',
        component: () => import(/* webpackChunkName: "portfolioDataManage" */ '@/views/manage/portfolioDataManage/index.vue'),
        meta: {
          title: '投资参数设定',
          icon: 'invest_planning_params',
          activeMenu: '/manage/portfolioDataManage'
        }
      },
      {
        path: '/manage/investProductManage',
        resourceId: '1802',
        parentId: '18',
        component: () => import(/* webpackChunkName: "investProductManage" */ '@/views/manage/investProductManage/index.vue'),
        meta: {
          title: '投资产品管理',
          icon: 'invest_product_admin',
          activeMenu: '/manage/investProductManage'
        }
      },
      {
        path: '/manage/insuranceProductManage',
        resourceId: '1803',
        parentId: '18',
        component: () => import(/* webpackChunkName: "insuranceProductManage" */ '@/views/manage/insuranceProductManage/index.vue'),
        meta: {
          title: '保险产品管理',
          icon: 'Insurance_product_admin',
          activeMenu: '/manage/insuranceProductManage'
        }
      },
      {
        path: '/manage/userManage',
        resourceId: '1804',
        parentId: '18',
        component: () => import(/* webpackChunkName: "manageUserManage" */ '@/views/manage/userManage/index.vue'),
        meta: {
          title: '用户管理',
          icon: 'el-icon-user-solid',
          activeMenu: '/manage/userManage'
        }
      },
      {
        path: '/manage/roleManage',
        resourceId: '1805',
        breadcrumb: false,
        parentId: '18',
        component: () => import(/* webpackChunkName: "manageRoleManage" */ '@/views/manage/roleManage/index.vue'),
        meta: {
          title: '角色管理',
          icon: 'el-icon-s-claim',
          activeMenu: '/manage/roleManage'
        }
      },
      {
        path: '/manage/roleSetting',
        name: 'manageRoleSetting',
        component: () => import(/* webpackChunkName: "manageRoleSetting" */ '@/views/manage/roleManage/roleSetting.vue'),
        meta: {
          title: '权限设置',
          icon: 'el-icon-s-order',
          activeMenu: '/manage/roleManage',
          hidden: true
        }
      },
      {
        path: '/manage/userLicense',
        resourceId: '1806',
        parentId: '18',
        component: () => import(/* webpackChunkName: "manageUserLicense" */ '@/views/manage/userLicense/index.vue'),
        meta: {
          title: '许可证查询',
          icon: 'el-icon-s-ticket',
          activeMenu: '/manage/userLicense'
        }
      },
      {
        path: '/manage/dataObservation',
        resourceId: '1807',
        parentId: '18',
        component: () => import(/* webpackChunkName: "manageUserLicense" */ '@/views/manage/dataObservation/index.vue'),
        meta: {
          title: '数据看板',
          icon: 'el-icon-s-data',
          activeMenu: '/manage/dataObservation'
        }
      }
    ]
  }
]
